

<template>
  <div>
    <!--    Breadcrumb Section Component-->
    <breadcrumb :breadcrumb="breadcrumb"/>
    <!--    Product Section Component-->
    <product-details-area/>
    <!--    Pizza Slider Section Component-->
    <pizza-slider-area/>
  </div>
</template>
<script>
import Breadcrumb from "../components/Breadcrumb";
import ProductDetailsArea from "../components/products/ProductDetailsArea";
import PizzaSliderArea from "../components/PizzaSliderArea";

export default {
  name: 'ProductDetails',
  components: {PizzaSliderArea, ProductDetailsArea, Breadcrumb},
  data() {
    return {
      breadcrumb: {
        title: 'Product Details',
        link: 'Product Details'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ProductDetails.vue